export const Months = [
  {
    digit: '01',
    month: 'January'
  },
  {
    digit: '02',
    month: 'February'
  },
  {
    digit: '03',
    month: 'March'
  },
  {
    digit: '04',
    month: 'April'
  },
  {
    digit: '05',
    month: 'May'
  },
  {
    digit: '06',
    month: 'June'
  },
  {
    digit: '07',
    month: 'July'
  },
  {
    digit: '08',
    month: 'August'
  },
  {
    digit: '09',
    month: 'September'
  },
  {
    digit: '10',
    month: 'October'
  },
  {
    digit: '11',
    month: 'November'
  },
  {
    digit: '12',
    month: 'December'
  }
];
